import Route from 'cio/routes/base';
import CampaignModel from 'cio/models/campaign';

export default class JourneyMetricsRoute extends Route {
  model() {
    return this.modelFor('campaigns.campaign');
  }

  redirect(model: CampaignModel) {
    this.router.transitionTo(
      `${model.isApiTriggered ? 'broadcasts.broadcast' : 'campaigns.campaign'}.overview.metrics`,
      model,
    );
  }
}
